module.exports = __webpack_public_path__ + "img/history.86eb99f7.svg";